import React from 'react';
import { useDarkMode } from '../../contexts/DarkModeContext';
import './QuickStats.css';
import { FaCalculator, FaTrophy, FaFire, FaStar } from 'react-icons/fa';

const QuickStats = () => {
    const { isDarkMode } = useDarkMode();
    
    // Get data from localStorage directly
    const calculatorPoints = parseInt(localStorage.getItem('calculator-points') || '0');
    const calculatorLevel = parseInt(localStorage.getItem('calculator-level') || '1');
    const calculations = parseInt(localStorage.getItem('calculator-calculations') || '0');
    const dailyStreak = parseInt(localStorage.getItem('daily-streak') || '0');
    const achievements = JSON.parse(localStorage.getItem('achievements') || '[]');

    const getLevelTitle = (level) => {
        if (level <= 5) return 'مبتدئ';
        if (level <= 10) return 'متوسط';
        if (level <= 15) return 'متقدم';
        if (level <= 20) return 'خبير';
        return 'أسطورة';
    };

    const getLevelIcon = (level) => {
        if (level <= 5) return <FaStar />;
        if (level <= 10) return <FaTrophy />;
        if (level <= 15) return <FaFire />;
        return <FaCalculator />;
    };

    return (
        <div className={`quick-stats-container  ${isDarkMode ? 'dark' : 'light'}`}>
            <div className="quick-stats-header text-white">
                <h3 className='text-white'>مسابقات وجوائز علمني</h3>
                <p className='text-white'>تتبع تقدمك في التعلم</p>
            </div>

            <div className="quick-stats-grid text-white">
                <div className="stat-card">
                    <div className="stat-icon calculator">
                        <FaCalculator />
                    </div>
                    <div className="stat-content">
                        <h4>الحاسبة العلمية</h4>
                        <p className="stat-value">{calculatorPoints} نقطة</p>
                        <p className="stat-subtitle text-white">
                            {getLevelIcon(calculatorLevel)} {getLevelTitle(calculatorLevel)} (المستوى {calculatorLevel})
                        </p>
                    </div>
                </div>

                <div className="stat-card">
                    <div className="stat-icon calculations">
                        <FaCalculator />
                    </div>
                    <div className="stat-content">
                        <h4>العمليات المكتملة</h4>
                        <p className="stat-value">{calculations}</p>
                        <p className="stat-subtitle">عملية حسابية</p>
                    </div>
                </div>

                <div className="stat-card">
                    <div className="stat-icon streak">
                        <FaFire />
                    </div>
                    <div className="stat-content">
                        <h4>التحدي اليومي</h4>
                        <p className="stat-value">{dailyStreak}</p>
                        <p className="stat-subtitle">يوم متتالي</p>
                    </div>
                </div>

                <div className="stat-card">
                    <div className="stat-icon achievements">
                        <FaTrophy />
                    </div>
                    <div className="stat-content">
                        <h4>الإنجازات</h4>
                        <p className="stat-value">{achievements.length}</p>
                        <p className="stat-subtitle">إنجاز مكتمل</p>
                    </div>
                </div>
            </div>

            <div className="quick-stats-actions">
                <a href="/competitions" className="action-btn calculator-btn">
                    <FaCalculator />
                    مسابقات وجوائز علمني
                </a>
            </div>
        </div>
    );
};

export default QuickStats; 